import { useMemo } from "react"
import { useManagedColumns } from "lib/@components/managed-columns/use-managed-columns"
import { useAssetDisplayFields } from "lib/@hooks/use-asset-display-fields"
import {
    AssetRegisterDisplayFields,
    buildRegisterColumns,
} from "routes/asset-register/asset-register-table/asset-register-column-definitions.mjs"
import { isMobiliserAdvancedMappingEnabled } from "routes/asset-register/plugins/asset-mapping/rollout-asset-fields"

export function useAssetRegisterColumns(registerId) {
    const assetDisplayFields = useAssetDisplayFields()
    const upgradesEnabled = isMobiliserAdvancedMappingEnabled()
    const displayFields = useMemo(buildDisplayFields, [assetDisplayFields])
    const allColumns = useMemo(getAllColumns, [displayFields, upgradesEnabled])

    return useManagedColumns({
        storageKey: `asset-register-columns.${registerId}`,
        allColumns,
        defaultPinnedField: "tag",
    })

    function buildDisplayFields() {
        return AssetRegisterDisplayFields.call({ displayFields: [...assetDisplayFields] })
    }

    function getAllColumns() {
        return buildRegisterColumns(displayFields, { typeLabel: upgradesEnabled ? "Imported Asset Type" : undefined })
    }
}
